// checklistQuestions.js

export const fireHazardsQuestions = [
    {
      key: "electricalInstallations",
      clause: "7.1",
      text: "Are all electrical installations and appliances regularly inspected, tested, and maintained to prevent fires of electrical origin?"
    },
    {
      key: "portableAppliances",
      clause: "7.2",
      text: "Are portable electrical appliances regularly checked and maintained for safety?"
    },
    {
      key: "extensionLeads",
      clause: "7.3",
      text: "Are extension leads and multi-adaptors used safely and not overloaded?"
    },
    {
      key: "smokingPolicy",
      clause: "7.4",
      text: "Is a clear no-smoking policy enforced throughout all areas (except where specifically permitted and controlled)?"
    },
    {
      key: "arsonPrevention",
      clause: "7.5",
      text: "Are external bins, skips, and other combustibles secured and sited away from buildings to reduce arson risk?"
    },
    {
      key: "heatingSystems",
      clause: "7.6",
      text: "Are all heating systems and portable heaters regularly checked, maintained, and safely positioned?"
    },
    {
      key: "cookingFacilities",
      clause: "7.7",
      text: "Are all cooking facilities (including staff kitchens) kept clean and provided with appropriate fire blankets or extinguishers?"
    },
    {
      key: "lightningProtection",
      clause: "7.8",
      text: "Is there an adequate and tested lightning protection system installed for the premises (if required)?"
    },
    {
      key: "housekeeping",
      clause: "7.9",
      text: "Are escape routes, exits, and final exits kept clear, accessible, and free of combustible materials at all times?"
    },
    {
      key: "flammableSubstances",
      clause: "7.10",
      text: "Are flammable liquids and substances stored and used in accordance with current legislation and best practice?"
    },
    {
      key: "fuelSources",
      clause: "7.11",
      text: "Are all fuel sources (e.g., gas, oil) properly controlled, maintained, and protected from unauthorised access?"
    },
    {
      key: "oxygenSources",
      clause: "7.12",
      text: "Are oxygen sources (including medical gases) properly identified, stored, and managed?"
    },
    {
      key: "contractorControl",
      clause: "7.13",
      text: "Are contractors and maintenance personnel supervised and made aware of relevant fire safety procedures?"
    },
    {
      key: "otherHazards",
      clause: "7.14",
      text: "Are there any other significant fire hazards present that require control measures?"
    },
    // Add after existing fireHazardsQuestions items

{
  key: "fixedInstallationsInspection",
  clause: "7.15",
  text: "Are fixed electrical installations periodically inspected and tested?"
},
{
  key: "portableApplianceTesting",
  clause: "7.16",
  text: "Is portable appliance testing carried out for all relevant items?"
},
{
  key: "personalApplianceControl",
  clause: "7.17",
  text: "Is there suitable control over the use of personal electrical appliances?"
},
{
  key: "trailingLeadsLimitation",
  clause: "7.18",
  text: "Is there suitable limitation of trailing leads and adapters?"
},
{
  key: "smokingArrangements",
  clause: "7.19",
  text: "Are there suitable arrangements for those who wish to smoke (e.g., designated areas, receptacles)?"
},
{
  key: "smokingPolicyObserved",
  clause: "7.20",
  text: "Did the smoking policy appear to be observed at time of inspection?"
},
{
  key: "arsonSecurity",
  clause: "7.21",
  text: "Does basic security against arson by outsiders appear reasonable?"
},
{
  key: "arsonFireLoad",
  clause: "7.22",
  text: "Is there an absence of unnecessary fire load in close proximity to the premises or available for ignition by outsiders?"
},
{
  key: "cookingDuctCleaning",
  clause: "7.23",
  text: "Are filters cleaned or changed, and ductwork cleaned regularly in cooking areas?"
},
{
  key: "combustibleSeparation",
  clause: "7.24",
  text: "Do combustible materials appear to be separated from ignition sources?"
},
{
  key: "combustibleAccumulation",
  clause: "7.25",
  text: "Is unnecessary accumulation or inappropriate storage of combustible materials or waste avoided?"
},
{
  key: "contractorHotWorkPermit",
  clause: "7.26",
  text: "Where appropriate, is a permit to work system used for 'hot work' by contractors?"
},
{
  key: "contractorPrecautions",
  clause: "7.27",
  text: "Are suitable precautions taken by in-house maintenance personnel or contractors who carry out works?"
},
{
  key: "dangerousSubstancesPrecautions",
  clause: "7.28",
  text: "Are the general fire precautions adequate to address hazards associated with dangerous substances used or stored within the premises?"
}

  ];
  
  export const fireProtectionQuestions = [
    {
      key: "compartmentation",
      clause: "8.1",
      text: "Is fire compartmentation adequate and maintained to prevent fire and smoke spread?"
    },
    {
      key: "fireDoors",
      clause: "8.2",
      text: "Are all fire doors fitted with appropriate self-closing devices, kept shut, and in good repair?"
    },
    {
      key: "emergencyLighting",
      clause: "8.3",
      text: "Is emergency lighting provided and maintained in all necessary areas?"
    },
    {
      key: "escapeRoutes",
      clause: "8.4",
      text: "Are escape routes clearly marked, illuminated, and unobstructed?"
    },
    {
      key: "signage",
      clause: "8.5",
      text: "Is fire safety signage clear, visible, and up to date throughout the building?"
    },
    {
      key: "detectionSystem",
      clause: "8.6",
      text: "Is there a suitable and maintained fire detection and alarm system installed and tested regularly?"
    },
    {
      key: "portableExtinguishers",
      clause: "8.7",
      text: "Are the correct types and numbers of portable fire extinguishers provided, accessible, and maintained?"
    },

{
  key: "escapeCapacity",
  clause: "8.9",
  text: "Do staircase and exit capacities appear adequate for the number of occupants?"
},
{
  key: "travelDistanceSingle",
  clause: "8.10",
  text: "Are distances of travel to exits reasonable where escape is in a single direction?"
},
{
  key: "travelDistanceAlternative",
  clause: "8.11",
  text: "Are distances of travel reasonable where there are alternative means of escape?"
},
{
  key: "fireExitsProvision",
  clause: "8.12",
  text: "Is there adequate provision of fire exits?"
},
{
  key: "fireExitsOpenDirection",
  clause: "8.13",
  text: "Do fire exits open in the direction of escape, where necessary?"
},
{
  key: "revolvingSlidingDoors",
  clause: "8.14",
  text: "Are there satisfactory arrangements for escape where revolving or sliding doors are used as exits?"
},
{
  key: "securingExits",
  clause: "8.15",
  text: "Are the arrangements provided for securing exits satisfactory?"
},
{
  key: "escapeRoutesDisabled",
  clause: "8.16",
  text: "Are there reasonable arrangements for means of escape for disabled people?"
},
{
  key: "fireDampers",
  clause: "8.17",
  text: "Are fire dampers provided as necessary to protect escape routes from smoke and fire spread?"
},
{
  key: "alarmRemoteTransmission",
  clause: "8.18",
  text: "Is there remote transmission of fire alarm signals to a monitoring centre or keyholder?"
},
{
  key: "zonePlanDisplayed",
  clause: "8.19",
  text: "Is a fire alarm zone plan displayed at the fire alarm control panel?"
},
{
  key: "alarmFalseAlarmInfo",
  clause: "8.20",
  text: "Are there any records or relevant information on false alarm experience?"
},
{
  key: "extinguisherTypes",
  clause: "8.21",
  text: "What type(s) of fire extinguishing appliances are provided (portable, hose reels, fire blankets, etc.)?"
},
{
  key: "fixedSuppressionType",
  clause: "8.22",
  text: "What type of fixed automatic fire extinguishing system (if any) is installed?"
},
{
  key: "fixedSystemIsolation",
  clause: "8.23",
  text: "Are there appropriately sited facilities for electrical isolation of any photovoltaic (PV) cells, with signage to assist the fire and rescue service?"
},


    {
      key: "fixedSuppression",
      clause: "8.8",
      text: "Are any fixed automatic fire suppression systems (e.g., sprinklers, gas systems) regularly serviced and functional?"
    }
  ];
  












  export const managementQuestions = [
    {
      key: "emergencyPlan",
      clause: "9.1",
      text: "Is there a documented, up-to-date, and communicated emergency plan for fire situations?"
    },
    {
      key: "fireBrigade",
      clause: "9.2",
      text: "Are clear procedures in place for summoning the fire brigade and ensuring the building is easily located by emergency services?"
    },
    {
      key: "evacuationAccounting",
      clause: "9.3",
      text: "Are arrangements in place to account for all occupants after evacuation?"
    },
    {
      key: "highRiskEvacuation",
      clause: "9.4",
      text: "Are there specific arrangements for the evacuation of high-risk persons (e.g., disabled, children, elderly, or sleeping)?"
    },
    {
      key: "assemblyPoint",
      clause: "9.5",
      text: "Is there a designated and known fire assembly point for all staff and visitors?"
    },
    {
      key: "fireTraining",
      clause: "9.6",
      text: "Is all staff given fire safety induction and periodic refresher training appropriate to their roles?"
    },
    {
      key: "fireDrills",
      clause: "9.7",
      text: "Are regular fire evacuation drills carried out and records maintained?"
    },
    {
      key: "systemMaintenance",
      clause: "9.8",
      text: "Are all fire protection systems and safety equipment regularly tested, inspected, and maintained, with records kept?"
    },
    {
      key: "recordKeeping",
      clause: "9.9",
      text: "Are records of fire risk assessments, drills, training, maintenance, and tests up to date and available for inspection?"
    },
    // Add after existing managementQuestions items

{
  key: "fireSafetyArrangementsRecord",
  clause: "9.10",
  text: "Is there a suitable record of the fire safety arrangements for the premises?"
},
{
  key: "alarmInvestigationProcedures",
  clause: "9.11",
  text: "Are there adequate procedures for investigating fire alarm signals?"
},
{
  key: "summoningFireService",
  clause: "9.12",
  text: "Are there suitable arrangements for summoning the fire and rescue service?"
},
{
  key: "meetingFireService",
  clause: "9.13",
  text: "Are there suitable arrangements to meet the fire and rescue service on arrival and provide relevant information?"
},
{
  key: "evacuationAssistanceDisabled",
  clause: "9.14",
  text: "Are there adequate procedures for evacuation of any disabled people who are likely to be present?"
},
{
  key: "nominatedPersonsEvacuation",
  clause: "9.15",
  text: "Are there persons nominated to assist with evacuation, including evacuation of disabled people?"
},
{
  key: "nominatedPersonsExtinguishers",
  clause: "9.16",
  text: "Are there persons nominated to use fire extinguishing appliances?"
},
{
  key: "cooperationMultipleOccupiers",
  clause: "9.17",
  text: "If the premises are in multiple occupation, are there adequate arrangements for cooperation between duty holders?"
},
{
  key: "liaisonFireService",
  clause: "9.18",
  text: "Is there appropriate liaison with the fire and rescue service (e.g., familiarization visits)?"
},
{
  key: "routineInspections",
  clause: "9.19",
  text: "Are routine in-house inspections of fire precautions undertaken?"
},
{
  key: "roleSpecificTraining",
  clause: "9.20",
  text: "Are staff given additional training to cover any specific roles and responsibilities?"
},
{
  key: "trainingContentAdequate",
  clause: "9.21",
  text: "Is the content of training provided considered adequate?"
},
{
  key: "otherEmployersTraining",
  clause: "9.22",
  text: "When employees of another employer work in the premises, is appropriate information on fire risks and fire safety measures provided?"
},
{
  key: "maintenanceAdequate",
  clause: "9.23",
  text: "Is there adequate maintenance of the premises overall?"
},
{
  key: "fireAlarmTestingRoutine",
  clause: "9.24",
  text: "Is weekly testing and periodic servicing of the fire detection and fire alarm system undertaken?"
},
{
  key: "emergencyLightingRoutine",
  clause: "9.25",
  text: "Are monthly and annual testing routines in place for the emergency escape lighting?"
},
{
  key: "extinguisherMaintenance",
  clause: "9.26",
  text: "Is annual maintenance of fire extinguishing appliances undertaken?"
},
{
  key: "externalEscapeInspection",
  clause: "9.27",
  text: "Is periodic inspection of external escape staircases and gangways undertaken?"
},
{
  key: "risingMainsTesting",
  clause: "9.28",
  text: "Are six-monthly inspection and annual testing of rising mains undertaken?"
},
{
  key: "evacuationLiftTesting",
  clause: "9.29",
  text: "Are weekly and monthly testing, six-monthly inspection, and annual inspection/testing of evacuation lifts undertaken?"
},
{
  key: "sprinklerTesting",
  clause: "9.30",
  text: "Are weekly testing and periodic inspection of sprinkler installations undertaken?"
},
{
  key: "exitDoorChecks",
  clause: "9.31",
  text: "Are routine checks of final exit doors and/or security fastenings undertaken?"
},
{
  key: "lightningProtectionTesting",
  clause: "9.32",
  text: "Is annual inspection and testing of the lightning protection system undertaken?"
},
{
  key: "fireDrillRecords",
  clause: "9.33",
  text: "Are there appropriate records of fire drills?"
},
{
  key: "fireTrainingRecords",
  clause: "9.34",
  text: "Are there appropriate records of fire training?"
},
{
  key: "alarmTestRecords",
  clause: "9.35",
  text: "Are there appropriate records of fire alarm tests?"
},
{
  key: "falseAlarmRecords",
  clause: "9.36",
  text: "Are there appropriate records of false alarms?"
},
{
  key: "emergencyLightingRecords",
  clause: "9.37",
  text: "Are there appropriate records of emergency escape lighting tests?"
},
{
  key: "protectionSystemRecords",
  clause: "9.38",
  text: "Are there appropriate records of maintenance and testing of other fire protection systems and equipment?"
}

  ];
  
  